<ng-container [ngSwitch]="custom">
  <ng-container *ngSwitchCase="false">
    <div class="card-header">
      <ng-content select="[valgCardHeading]"></ng-content>
    </div>
    <div class="card-content">
      <ng-content select="[valgCardContent]"></ng-content>
    </div>
    <div class="card-action">
      <ng-content select="[valgCardAction]"></ng-content>
    </div>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-content></ng-content>
  </ng-container>
</ng-container>